<div class="vtz-main-wrapper">
  <div class="vtz-main-container vtz-main-container--home">
    <div class="vtz-title-section vtz-title-section--blue">
      <app-header></app-header>
    </div>    
    @if(electionOpen){
      <main aria-label="form">
        <h1 id="main-title" class="vtz-h1" i18n>Verify Code</h1>
        @if(electorDataService.userAuthData()?.mfaMethod === 'EMAIL'){
          <p class="vtz-text vtz-text--wide vtz-text--center" i18n>
            Please enter the 6-digit code that was sent to you by email.
          </p>
        } @else if(electorDataService.userAuthData()?.mfaMethod === 'SMS'){
          <p class="vtz-text vtz-text--wide vtz-text--center" i18n>
            Please enter the 6-digit code that was sent to you by text.
          </p>
        } @else {
          <p class="vtz-text vtz-text--wide vtz-text--center" i18n>
            Please enter the 6-digit code in your authenticator app.
          </p>
        }
        <div class="vtz-form"> 
          <div id="otp" class="otp-field">
            @for (index of numbers; track index) {
              <input
                #mfaRef
                type="text"
                maxlength="1"
                pattern="[0-9]"
                required
                [attr.aria-label]="'Digit ' + (index + 1) + ' of 6'"
                i18n-aria-label             
                autocomplete="off"
                (focus)="handleFocus($event)"
                (input)="handleInput($event, index)"
                (paste)="handlePaste($event)"
                (blur)="index === 5 && handleBlur($event)"
                (keydown)="handleKeydown($event, index)"
                inputmode="numeric"
              />
            }
          </div>

          @if(mfaFormGroup.get('code')?.hasError('invalidPaste')){
            <div role="alert" class="vtz-text--center">
              <span class="vtz-form__error" aria-live="assertive" i18n="Invalid form field">Pasted code must contain exactly 6 numbers.
              </span>
            </div>
          }
          @if(mfaFormGroup.get('code')?.hasError('invalidCode')){
            <div role="alert" class="vtz-text--center">
              <span class="vtz-form__error" aria-live="assertive" i18n="Invalid form field">Exactly six digits are required in this field.
              </span>
            </div>
          }

        </div>
        @if(electorDataService.userAuthData()?.mfaMethod !== 'APP') {
          <p class="vtz-text vtz-text--wide vtz-text--center" i18n>
            Your code will expire in {{electorDataService.mfaExpirationTimeMinutes()}} minutes.
          </p>
          @if(!maxMFAResendsReached && allowResends) {
            <p class="vtz-text vtz-text--wide vtz-text--center" i18n>
              Have you received your MFA code? <strong><a style="cursor:pointer" class="light_red" (click)="resendOTP()">Send it again.</a></strong>
            </p>
          }
        }
        <div class="vtz-actions">
          <div class="button-group">
            <button class="button button-primary" [disabled]="!isValid() || session.activeSessionCheck() || maxMFACodeAttemptsReached" (click)="submit()" i18n="Button label">VERIFY</button>
          </div>
        </div>
        @if(displaySpinner){
          <div class="progressSpinner">
            <mat-spinner [diameter]="300" color="primary"></mat-spinner>
            <div class="spinner-warning">
              <p i18n>Please do not refresh, click the browser back button, or close your browser.</p>
            </div>
          </div>
        }
      </main>
    } @else {
      <h1 id="main-title" class="vtz-h1" i18n>Election Closed</h1>
      <p class="vtz-text vtz-text--wide vtz-text--center" i18n>
        The election was open from {{aboutService.startTime}} to {{aboutService.endTime}}.
      </p>
    }
  </div>
</div>
<app-back-button-confirmation-modal>
</app-back-button-confirmation-modal>